(function () {
  'use strict';

  // Füllt auf Produktkarten den nächsten freien Termin aus Regiondo.
  // Nutzt dieselben Caches wie gg-kalender.js (gg_rg_map, gg_rg_times), damit
  // Kalender und Karten sich die Anfragen teilen.
  var felder = document.querySelectorAll('[data-gg-widget]');
  if (!felder.length) {
    return;
  }

  var WIDGET_BASE = 'https://partner-widgets-editor-backend.prod.regiondo.net/api/v1';
  var API_BASE = 'https://shopping-experience-api.prod.regiondo.net/api/v1';
  var HEADERS = {
    'x-locale': 'de-DE',
    'x-partner-code': 'GR167',
    'x-tenant': 'REGIONDO',
    'x-partner-domain': 'https://grimms-garten.regiondo.de/'
  };

  function lies(storage, key) {
    try {
      var raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function schreib(storage, key, wert) {
    try {
      storage.setItem(key, JSON.stringify(wert));
    } catch (e) {
    }
  }

  var map = lies(localStorage, 'gg_rg_map');
  map = (map && map.data && Date.now() - map.timestamp < 30 * 24 * 60 * 60 * 1000) ? map.data : {};
  var times = lies(sessionStorage, 'gg_rg_times') || {};

  function produktId(widgetId) {
    if (map[widgetId]) {
      return Promise.resolve(map[widgetId]);
    }
    return fetch(WIDGET_BASE + '/widgets/' + encodeURIComponent(widgetId) + '/configuration', { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var pId = d && d.settings && d.settings.productId ? String(d.settings.productId) : null;
        if (pId) {
          map[widgetId] = pId;
          schreib(localStorage, 'gg_rg_map', { timestamp: Date.now(), data: map });
        }
        return pId;
      });
  }

  function termine(pId) {
    var c = times[pId];
    if (c && Date.now() - c.timestamp < 30 * 60 * 1000) {
      return Promise.resolve(c.days);
    }
    return fetch(API_BASE + '/timeslots/times?productId=' + encodeURIComponent(pId), { mode: 'cors', headers: HEADERS })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var days = {};
        var src = d && d.days ? d.days : {};
        Object.keys(src).forEach(function (tag) {
          var t = src[tag] && src[tag].times ? src[tag].times : {};
          days[tag] = Object.keys(t).sort().map(function (zeit) {
            return {
              zeit: zeit,
              frei: typeof t[zeit].availableQuantity === 'number' ? t[zeit].availableQuantity : 0,
              gesamt: typeof t[zeit].capacity === 'number' ? t[zeit].capacity : 0
            };
          });
        });
        times[pId] = { timestamp: Date.now(), days: days };
        schreib(sessionStorage, 'gg_rg_times', times);
        return days;
      });
  }

  function ersterFreier(days) {
    var heute = new Date();
    heute.setHours(0, 0, 0, 0);
    var tage = Object.keys(days).sort();
    for (var i = 0; i < tage.length; i++) {
      var p = tage[i].split('-');
      var datum = new Date(+p[0], p[1] - 1, +p[2]);
      if (datum < heute) {
        continue;
      }
      var slots = days[tage[i]];
      for (var j = 0; j < slots.length; j++) {
        if (slots[j].frei > 0) {
          return { datum: datum, slot: slots[j] };
        }
      }
    }
    return null;
  }

  function zeige(feld, treffer) {
    var text = feld.querySelector('[data-gg-termin-text]');
    if (!treffer) {
      text.textContent = 'auf Anfrage';
    } else {
      var d = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }).format(treffer.datum);
      text.textContent = d + ', ' + treffer.slot.zeit + ' Uhr';
      if (treffer.slot.frei <= 2) {
        text.textContent += ' (noch ' + treffer.slot.frei + (treffer.slot.frei === 1 ? ' Platz)' : ' Plätze)');
      }
    }
    feld.hidden = false;
  }

  Array.prototype.forEach.call(felder, function (feld) {
    var widgetId = feld.getAttribute('data-gg-widget');
    produktId(widgetId)
      .then(function (pId) { return pId ? termine(pId) : null; })
      .then(function (days) {
        if (days) {
          zeige(feld, ersterFreier(days));
        }
      })
      .catch(function () {
      });
  });
})();
